import type { Locale } from '$lib/i18n/types';
import type { Pagename } from '$lib/services/urls/routesPagename';
import type { BookingcomLabelBaseData, BookingcomLabelBuildDataNullable, BookingcomLabelDataNullable } from './types';
import { page } from '$app/state';
import { isLargeDevice, isSmallDevice } from '$lib/utils/getPlatform';
import { mapLocaleToTld } from './constants';
import { BOOKING_LABEL_SCHEMA, BOOKINGCOM_DEVICE_TYPE as DEVICE_TYPE } from './types';

// Documentation produit 'Labels Booking': https://www.notion.so/Labels-Booking-1a0bd4bbe4f18038960aee89cda0f1cd

function buildBookingLabelData(locale: Locale, pagename: Pagename, labelBuildParams: BookingcomLabelBuildDataNullable): BookingcomLabelDataNullable {
	const deviceType = getBookingLabelDeviceType();
	const domain = mapLocaleToTld[locale];

	const baseData: BookingcomLabelBaseData = {
		clientId: 'viam' as const,
		tld: domain,
		deviceType,
		timestamp: Date.now().toString(),
		keys: {},
		values: {},
		trackingAcquisition: page.data?.trackingAcquisition,
		pagename,
	};

	return { ...baseData, ...labelBuildParams };
}

export function serializeLabelForBookingComUrl(locale: Locale, pagename: Pagename, labelBuildParams: BookingcomLabelBuildDataNullable): string {
	const labelData = buildBookingLabelData(locale, pagename, labelBuildParams);

	return BOOKING_LABEL_SCHEMA.map((key) => {
		const value = labelData?.[key as keyof typeof labelData];
		if (value === undefined) {
			return '';
		}

		// Convert value to string and encode special characters
		const stringValue = typeof value === 'object' ? '' : value.toString();
		return stringValue;
	}).join('|');
}

function getBookingLabelDeviceType() {
	if (isSmallDevice()) {
		return DEVICE_TYPE.PHONE;
	} else if (isLargeDevice()) {
		return DEVICE_TYPE.DESKTOP;
	}
	return DEVICE_TYPE.TABLET;
}
